$(".scroll-text-slider").slick({
  speed: 17000,
  autoplay: true,
  autoplaySpeed: 0,
  cssEase: "linear",
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: true,
  dots: false,
  arrows: false,
  pauseOnHover: false,
});
$(".slider-scroll").slick({
  speed: 25000,
  autoplay: true,
  autoplaySpeed: 0,
  infinite: true,
  cssEase: "linear",
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: true,
  dots: false,
  arrows: false,
  pauseOnHover: false,
});
$(document).ready(function () {
  // Hide the div initially
 $('#shopify-section-announcement-bar').show();
  // Show the div after page load
  //$('#shopify-section-announcement-bar').fadeIn('slow'); // Adjust the animation speed as needed
});

$(".home-three-callout").slick({
  autoplay: false,
  autoplaySpeed: 2000,
  speed: 100,
  dots: false,
  arrows: false,
  mobileFirst: true,
  centerMode: true,
  centerPadding: "20px",
  responsive: [
    {
      breakpoint: 768,
      settings: "unslick",
    },
  ],
});

$(document).ready(function () {
  $(".announ-close").click(function () {
    $(".sticky-footer").remove();
     $("#shopify-section-announcement-bar").remove();
    
  });
});

$(window).on("scroll", function () {
  $("div").each(function () {
    if (
      $(this).offset().top < $(window).scrollTop() + $(window).height() &&
      $(this).offset().top + $(this).height() > $(window).scrollTop()
    ) {
      var div_id = this.id;
      //$('.sticky-footer').show();
      if (div_id == "scrolling-text") {
        $(".sticky-footer").hide();
      }
      if (div_id == "collection-feu") {
        //alert('gg');
        $(".sticky-footer").show();
      }
    }
  });
});

//var images = [
// "https://cdn.shopify.com/s/files/1/0712/4706/9473/files/Mug_Front-removebg-preview.png?v=1675490771",
// "https://cdn.shopify.com/s/files/1/0712/4706/9473/files/5483741-removebg-preview.png?v=1675490314",
// "https://cdn.shopify.com/s/files/1/0712/4706/9473/files/Frog_Tote_-_Small_-_Thumb_copy-removebg-preview.png?v=1675491487",
// "https://cdn.shopify.com/s/files/1/0712/4706/9473/files/Bad_Jelly-removebg-preview.png?v=1675490888"

//];

//$(document).ready(function() {
//$(".logo-changes-images").click(function() {
//  var count_images = $('.images-count').length;
//var randomIndex = Math.floor(count_images);
//alert(randomIndex);
//var randomImage = images[randomIndex];

//if(count_images < 4) {
//   $(".images-count").show();
//$(this).append(
//  "<img class='image-count-" + count_images + " images-count' src='" + randomImage + "' >"
// );
// }
//else {
//  $(".images-count").remove();
//}
//});
//});

$(document).ready(function () {
  setInterval(function () {
    var date = new Date();
    //var month = date.getMonth();
    var month = ("0" + (date.getMonth() + 1)).slice(-2);
    //var day =  date.getDate();
    var day = ("0" + date.getDate()).slice(-2);
    var year = date.getFullYear();
    //var hours = date.getHours();
    var hours = ("0" + date.getHours()).substr(-2);
    //var minutes = date.getMinutes();
    var minutes = ("0" + date.getMinutes()).slice(-2);
    var seconds = date.getSeconds();
    var hourDeg = (hours / 12) * 360 + (minutes / 60) * 30;
    var minuteDeg = (minutes / 60) * 360 + (seconds / 60) * 6;
    var secondDeg = (seconds / 60) * 360;
    $(".hour-hand").css("transform", "rotate(" + hourDeg + "deg)");
    $(".minute-hand").css("transform", "rotate(" + minuteDeg + "deg)");
    $(".second-hand").css("transform", "rotate(" + secondDeg + "deg)");
    $("#CartDrawer-ColumnProduct").html(day + "/" + month + "/" + year);
    $("#CartDrawer-ColumnTotal").html(hours + ":" + minutes);
    $(".cart-top-date").html(day + "/" + month + "/" + year);
    //$(".cart-top-time").html(hours + ":" + minutes);

    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds_0 = ("0" + date.getSeconds()).slice(-2);
    var ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var hours_2 =("0" + hours).slice(-2);
    var strTime = hours + ":" + minutes + " " + ampm;
    var strTime_footer = hours_2 + ":" + minutes + ":" + seconds_0 + ampm;
    $(".cart-top-time").html(strTime);
    $(".foote_bottom_clock").html(strTime_footer);
    return strTime;
  }, 1000);
});

$(document).ready(function () {
  //$("#ajax-button").click(function() {
  var accessToken =
    "BQBhBWLtvIi4BawalcxM-__EpiI-8gBJzq-JG_U306CoZTj4HcRG-q8FDmnAZdq7zm9V4upnXRyPKWy4zXtyuAzt16-nsHRTHgZNKpd49tI6EiLzuOe8dEIXx6FO20ommb-dEaM29hmjX49Hki3X3jpNL4AJkZNv8VUkbnS6wf9KGVw4H5rgTRvRSFo80uYl6-evEroA_JbB";
  $.ajax({
    url: "https://api.spotify.com/v1/me/player/currently-playing",
    type: "GET",
    headers: {
      Authorization: "Bearer " + accessToken,
    },
    success: function (response) {
      //alert(response);
      if (response != undefined) {
        var artist = response.item.artists;
        var artist = artist[0].name;
        var song_name = response.item.name;
        //console.log(response.item);
        $("#ajax-button").html(artist + "-" + song_name);
        // You can access the track information such as track name, artist, album, etc.
      }
    },
    error: function (xhr, response, error) {
      //console.log(error);
    },
  });
  // });
});

$(document).ready(function () {
  //$('.popup-custom').insertAfter('.custom-description');
});

var image = new Array();
image[0] =
  "https://cdn.shopify.com/s/files/1/0712/4706/9473/files/Ladybird_-_Home_1.svg?v=1676379525";
image[1] =
  "https://cdn.shopify.com/s/files/1/0712/4706/9473/files/Outhouse_f5a77fe9-7813-471a-8a6a-6748f437d252.svg?v=1676379480";
image[2] =
  "https://cdn.shopify.com/s/files/1/0712/4706/9473/files/Dog_1.svg?v=1676379026";
var size = image.length;
var x = Math.floor(size * Math.random());

$(".random-images").attr("src", image[x]);

//$(document).ready(function() {
//$('.bottom-cart-keep').click(function() {
//$('#main-cart-drawer').removeClass('active');
//$('body').removeClass('overflow-hidden');
//});
//});

$(document).ready(function () {
  // Generate random position and speed for each element
  $(".about-us-multi-item").each(function () {
    var x = Math.floor(Math.random() * $(window).width());
    var y = Math.floor(Math.random() * $(window).height());
    var speed = Math.random() * 10;
    $(this).css({
      left: x + "px",
      top: y + "px",
      transition: "top " + speed + "s linear",
    });
  });

  var isDragging = false;
  var currentElement = null;
  var currentX;
  var currentY;
  var initialX;
  var initialY;
  var xOffset = 0;
  var yOffset = 0;

  $(".about-us-multi-item").on("mousedown", function (e) {
    isDragging = true;
    currentElement = this;
    initialX = e.clientX - xOffset;
    initialY = e.clientY - yOffset;

    $(currentElement).css("transition", "none");
  });

  $(document).on("mouseup", function () {
    isDragging = false;
    $(currentElement).css("transition", "top " + 250 + "s linear");
  });

  $(document).on("mousemove", function (e) {
    if (isDragging) {
      e.preventDefault();
      currentX = e.clientX - initialX;
      currentY = e.clientY - initialY;

      xOffset = currentX;
      yOffset = currentY;

      $(currentElement).css("top", currentY + "px");
      $(currentElement).css("left", currentX + "px");
    }
  });
});

$(document).ready(function () {
  $(".Shop.menu-drawer__menu-item").click(function () {
    $(".menu-drawer-container").removeClass("menu-opening");
    $("body").removeClass("overflow-hidden-tablet");
    $(".menu-drawer-container").removeAttr("open");
    $(".header__icon--menu").attr("aria-expanded", "false");
  });
});

if (screen.width < 750) {
  $(".toggle_btn").click(function () {
    $(this).toggleClass("active-desn");
    $(".product__description").toggleClass("active-desn");

    if ($(".toggle_btn").hasClass("active-desn")) {
      $(".toggle_btn").text("Read Less -");
    } else {
      $(".toggle_btn").text("Read More +");
    }
  });
}

window.addEventListener("scroll", function () {
  const element_s = document.getElementById("main-cart-drawer");
  element_s.classList.remove("active");
});

//$(document).ready(function () {
// var quantitySelector = $(".quantity__input");
//var productPrice = $(".hidden_price").text();
//quantitySelector.on("change", function () {
// function updateLatestValue() {
// latestValue = productPrice;
//console.log("Latest Value:", latestValue);
//}
// var quantity = $(this).val();
//var avoid = "A$";
//var prices = productPrice.replace(avoid, "");
//var newPrice = quantity * prices;
//alert(productPrice);
//$(".price-item--regular").text("A$" + newPrice);
// updateLatestValue();
//});
//});

$(document).ready(function () {
  var days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  var months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  var currentDate = new Date();
  var day = days[currentDate.getDay()];
  var date = currentDate.getDate();
  var month = months[currentDate.getMonth()];

  var formattedDate = day + " " + date + " " + month;
  $("#date").text(formattedDate);
});

$(document).ready(function(){
  $(".link_option_current").click(function(){
    $(this).toggleClass("opactv");
    $(".link_option_other").toggle();     
  });

 $(document).on("click", function (e) {
        if ($(e.target).is(".link_option_current") === false) {
             $(".link_option_current").removeClass("opactv");
             $(".link_option_other").hide();  
}
});
  
});



function redirectToUrl() {
      const selectElement = document.getElementById('url-select');
      const selectedValue = selectElement.value;

      if (selectedValue) {
        window.location.href = selectedValue;
      }
    }



$(document).ready(function () {

  function convertCMtoInches(input) {
    return input.replace(/(\d+(\.\d+)?)/g, function (num) {
      return (parseFloat(num) / 2.54).toFixed(2);
    });
  }

  // Store original CM & converted inches
  $(".sizes").each(function () {
    let original = $(this).text().trim();

    // remove quotes if any
    original = original.replace(/"/g, "").trim();

    // Save original CM value
    $(this).attr("data-cm", original);

    // Convert every number inside the string
    let inchValue = convertCMtoInches(original);

    // Save inches version
    $(this).attr("data-inches", inchValue);
  });

  // Default CM view
  showCM();
  $(".units_cm").addClass("active");

  // CLICK → CM (no ")
  $(".units_cm").click(function () {
    $(".units_inches").removeClass("active");
    $(".units_cm").addClass("active");
    $(".size-symb").hide();
    showCM();
  });

  // CLICK → Inches (add " at END of string)
  $(".units_inches").click(function () {
    $(".units_cm").removeClass("active");
    $(".units_inches").addClass("active");
    $(".size-symb").show();
    showInches();
  });

  // SHOW CM (original, no unit)
  function showCM() {
    $(".sizes").each(function () {
      let cm = $(this).attr("data-cm");
      $(this).text(cm);
    });
  }

  // SHOW INCHES (converted, add " at END ONLY)
  function showInches() {
    $(".sizes").each(function () {
      let inches = $(this).attr("data-inches");
      //$(this).text(inches + `<span>"</span>`);
      $(this).html(`${inches}<span>"</span>`);
    });
  }

});